import React from "react";
// eslint-disable-next-line import/no-cycle
import { SvgProps } from ".";

export const ExtLink: React.FC<SvgProps> = ({ height, width }) => (
  <svg
    width={width || "25px"}
    height={height || "25px"}
    viewBox="0 0 27 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="external-link-svg">External Link</title>
    <g
      id="Event-Location"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Local/Webinar/Special-Event-Template---Mobile-Auth"
        transform="translate(-294.000000, -782.000000)"
      >
        <g id="Group" transform="translate(287.325403, 775.000000)">
          <g transform="translate(20.000000, 20.000000) rotate(-180.000000) translate(-20.000000, -20.000000) translate(0.000000, -0.000000)">
            <rect
              id="Rectangle"
              x="-2.36847579e-14"
              y="0"
              width="40"
              height="40"
            />
            <path
              d="M8,17.9657143 L8,9.14285714 C8,8.51167457 8.51167457,8 9.14285714,8 L30.8571429,8 C31.4883254,8 32,8.51167457 32,9.14285714 L32,30.8571429 C32,31.4883254 31.4883254,32 30.8571429,32 L22.0342857,32"
              id="Path"
              stroke="#252525"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <polyline
              id="Path"
              stroke="#252525"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              transform="translate(11.428571, 28.571429) rotate(-180.000000) translate(-11.428571, -28.571429) "
              points="8 25.1428571 14.8571429 25.1428571 14.8571429 32"
            />
            <line
              x1="20.5790476"
              y1="19.6114286"
              x2="8.19047619"
              y2="32"
              id="Path"
              stroke="#252525"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default {};
